<template>
  <div class="important-page-c display--flex fd--column">
    <!-- 搜索 -->
    <div
      class="search-form btn-2b5a95"
    >
<div class="l-w" :style="{
        height: $store.state.global.isSearchExtend_1
          ? ''
          : $store.state.global.searchFormHeight_1 + 10 + 'px',
      }">
      <el-form
        label-position="right"
        :class="$store.state.global.isSearchExtend_1 ? '' : 'overflow--hidden'"
				@submit.native.prevent
				:model="searchForm"
      >
        <el-form-item label="转账金额:">
          <el-input 
						v-model.trim="searchForm.amount" 
						@keyup.enter.native="seach"
						clearable />
        </el-form-item>
        <el-form-item label="转出账号卡号:">
          <el-input 
						v-model.trim="searchForm.bankaccountcardno1" 
						@keyup.enter.native="seach"
						clearable />
        </el-form-item>
        <el-form-item label="转入账号卡号:">
          <el-input 
						v-model.trim="searchForm.bankaccountbookno1"
						@keyup.enter.native="seach" 
						clearable />
        </el-form-item>
        <el-form-item label="所属教学点:">
          <el-input 
						v-model.trim="searchForm.schoolorgname" 
						@keyup.enter.native="seach"
						clearable />
        </el-form-item>
				<el-form-item label="操作人:">
				  <el-input 
						v-model.trim="searchForm.username"
						@keyup.enter.native="seach"
						clearable />
				</el-form-item>
      </el-form>
    </div>
      <div class="r-w">

      <el-button
        type="primary"
        icon="el-icon-search"
        @click="seach"
        :loading="!$store.state.global.isEndRequest"
        class="btn-2b5a95"
        >搜索</el-button
      >
			<el-button type="primary" @click="resetQuery">重置</el-button>
      <el-button
        type="primary"
        :icon="
          $store.state.global.isSearchExtend_1
            ? 'el-icon-arrow-up'
            : 'el-icon-arrow-down'
        "
        v-if="$store.state.global.searchExtend_1"
        class="btn-2b5a95"
        @click="onExtendClick('isSearchExtend_1')"
        >{{ $store.state.global.searchExtendText_1 }}</el-button
      >
    </div>

    </div>

    <!-- 按钮操作 -->
    <div
      class="Btn-w eaf4ff-btn"
      v-if="tableRes.buttonlist && tableRes.buttonlist.length"
      :style="{
        height: $store.state.global.isBtnExtend_1
          ? ''
          : $store.state.global.BtnHeight_1 + 10 + 'px',
      }"
    >
      <div
        class="btn-l"
        v-if="tableRes.buttonlist"
        :class="$store.state.global.isBtnExtend_1 ? '' : 'overflow--hidden'"
      >
        <el-button
          v-for="(item, index) in tableRes.buttonlist"
          :key="index"
          type="primary"
          @click="onClickBtn(item.buttonname)"
          >{{ item.name }}
        </el-button>
      </div>
      <div class="Btn-extend">
        <el-button
          type="primary"
          v-if="$store.state.global.btnExtend_1"
          class="btn-2b5a95"
          :icon="
            $store.state.global.isBtnExtend_1
              ? 'el-icon-arrow-up'
              : 'el-icon-arrow-down'
          "
          @click="onExtendClick('isBtnExtend_1')"
          >{{ $store.state.global.BtnExtendText_1 }}</el-button
        >
      </div>
    </div>

    <!-- 表格 -->
    <el-table
      :data="tableRes.list"
      border
			stripe
			:header-cell-style="{ background: '#044d8c', color: '#fff'}"
      ref="multipleTable"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55" />
      <el-table-column label="转账金额" prop="amount" align="center" >
				<template slot-scope="scope">
				  <el-button @click="btnShowDetail(scope.row)" type="text">{{
				    scope.row.amount
				  }}</el-button>
				</template>
			</el-table-column>
      <el-table-column
        label="转出账号卡号"
        prop="bankaccountcardno1"
        align="center"
      />
      <el-table-column
        label="转出账号当前余额"
        prop="bankcuramount1"
        align="center"
      />
      <el-table-column
        label="转入账号卡号"
        prop="bankaccountcardno2"
        align="center"
      />
      <el-table-column
        label="转入账号当前余额"
        prop="bankcuramount2"
        align="center"
      />
      <el-table-column label="操作时间" align="center" width="160">
        <template slot-scope="scope">
          {{ scope.row.optime | formatDate("YYYY-MM-DD HH:mm:ss") }}
        </template>
      </el-table-column>
      <el-table-column label="操作人名称" prop="username" align="center" />
      <el-table-column label="教学点" prop="schoolorgname" align="center" />
      <el-table-column label="分公司" prop="companyorgname" align="center" />
    </el-table>

    <!-- 分页 -->
    <el-pagination
      background
      @current-change="handleCurrentChange"
      :current-page="pageinfo.pageindex"
      :page-size="pageinfo.pagesize"
      :page-sizes="[10, 20, 30, 40, 50]"
      layout="total, prev, pager, next, jumper"
      :total="tableRes.totalcount"
    ></el-pagination>

    <!--添加，修改-->
    <el-dialog
      class="btn-2b5a95"
			v-dialogDrag
      width="60%"
      :visible.sync="showAddModal"
      v-if="showAddModal"
			:close-on-click-modal='false'
      append-to-body
			:title="this.dialogTitle"
    >
      <el-form
        :model="dynamicValidateForm"
        ref="dynamicValidateForm"
        label-width="35%"
        class="demo-dynamic form-item-w-50"
        status-icon
        :rules="rules"
      >
        <el-form-item prop="cashaccountname" label="转出账号开户名称:">
          <el-input
            v-model="dynamicValidateForm.cashaccountname"
            placeholder="请选择"
            disabled
          />
          <el-button
            type="primary"
            class="select-btn"
            @click="onSelectData(account_dialogbankresult, 'showOutModal')"
            >选择</el-button
          >
        </el-form-item>
        <el-form-item label="转出账号卡号">
          <el-input v-model="dynamicValidateForm.bankaccountcardno1" disabled />
        </el-form-item>
        <el-form-item label="转出账号当前金额">
          <el-input v-model="dynamicValidateForm.bankcuramount1" disabled />
        </el-form-item>
        <el-form-item prop="bankaccountaccountname" label="转入账号开户名称:">
          <el-input
            v-model="dynamicValidateForm.bankaccountaccountname"
            placeholder="请选择"
            disabled
          />
          <el-button
            type="primary"
            class="select-btn"
            @click="onSelectData(account_dialogbankresult, 'showIntoModal')"
            >选择</el-button
          >
        </el-form-item>
        <el-form-item label="转入账号卡号">
          <el-input v-model="dynamicValidateForm.bankaccountbookno1" disabled />
        </el-form-item>
        <el-form-item label="转入账号当前金额">
          <el-input v-model="dynamicValidateForm.bankcuramount2" disabled />
        </el-form-item>
        <el-form-item prop="amount" label="金额:">
          <el-input v-model.trim="dynamicValidateForm.amount" clearable/>
        </el-form-item>
        <el-form-item prop="optime" label="转账时间">
          <el-date-picker
            v-model="dynamicValidateForm.optime"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择取现时间"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="submitAddOrEditForm('dynamicValidateForm')"
          :loading="!$store.state.global.isEndRequest"
          >提交
        </el-button>
      </span>
    </el-dialog>

    <!-- 选择转出账户 -->
    <el-dialog
      class="btn-2b5a95"
      width="77%"
			v-dialogDrag
      @close="onCloseSelect"
      title="选择转出账户："
      :visible.sync="showOutModal"
			v-if="showOutModal"
			:close-on-click-modal='false'
      append-to-body
    >
      <el-button type="primary" @click="onConfirmOut">确定</el-button>

		<div class="index_2 btn-2b5a95">
        <div
          class="l-w"
          :style="{
            height: $store.state.global.isSearchExtend_2
              ? ''
              : $store.state.global.searchFormHeight_2 + 10 + 'px',
          }"
        >
          <el-form
            label-position="right"
            :class="
              $store.state.global.isSearchExtend_2 ? '' : 'overflow--hidden'
            "
            :model="selectSearchForm"
						@submit.native.prevent
          >
            <el-form-item label="开户名称:" prop="accountname">
              <el-input 
								v-model.trim="selectSearchForm.accountname" 
								@keyup.enter.native="onSelectSearchClick(
                selectTableUrl,
                null,
                Object.assign({}, selectSearchForm)
              )"
								clearable />
            </el-form-item>
            <el-form-item label="银行卡号:" prop="cardno">
              <el-input 
								v-model.trim="selectSearchForm.cardno"
								@keyup.enter.native="onSelectSearchClick(
								  selectTableUrl,
								  null,
								  Object.assign({}, selectSearchForm)
								)"
								clearable />
            </el-form-item>
          </el-form>
        </div>
        <div class="r-w">
          <el-button
            type="primary"
            icon="el-icon-search"
            :loading="!$store.state.global.isEndRequest"
            class="btn-2b5a95"
            @click="
              onSelectSearchClick(
                selectTableUrl,
                null,
                Object.assign({}, selectSearchForm)
              )
            "
            >搜索</el-button
          >
					<el-button type="primary" @click="handleQuery">重置</el-button>
          <el-button
            type="primary"
            :icon="
              $store.state.global.isSearchExtend_2
                ? 'el-icon-arrow-up'
                : 'el-icon-arrow-down'
            "
            v-if="$store.state.global.searchExtend_2"
            class="btn-2b5a95"
            @click="onExtendClick('isSearchExtend_2')"
            >{{ $store.state.global.searchExtendText_2 }}</el-button
          >
        </div>
      </div>


      <el-table
        :data="selectTable.list"
        style="width: 100%"
        ref="moneyTable"
				border
				stripe
				:key="key"
				:header-cell-style="{background: '#004d8c', color:'#FFFFFF'}"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" />
        <el-table-column label="流水号" prop="id" align="center" />
        <el-table-column label="开户名称" prop="accountname" align="center" />
        <el-table-column label="银行名称" prop="bankname" align="center" />
        <el-table-column label="当前余额" prop="curmoney" align="center" />
        <el-table-column label="存折账号" prop="bookno" align="center" />
        <el-table-column label="银行卡号" prop="cardno" align="center" />
        <el-table-column
          label="是否总部POS机"
          prop="isposflag"
          align="center"
        />
        <el-table-column label="状态" prop="approvestate" align="center" />
        <el-table-column
          label="所属分公司名称"
          prop="companyorgname"
          align="center"
        />
        <el-table-column
          label="所属教学点名称"
          prop="schoolorgname"
          align="center"
        />
      </el-table>
      <el-pagination
        background
        @current-change="(val, data)=>handleSelectChange(val,selectSearchForm)"
        :current-page="selectPageInfo.pageindex"
        :page-size="selectPageInfo.pagesize"
        :page-sizes="[10, 20, 30, 40, 50]"
        layout="total, prev, pager, next, jumper"
        :total="selectTable.totalcount"
      ></el-pagination>
    </el-dialog>

    <!-- 选择转入账户 -->
    <el-dialog
      class="btn-2b5a95"
      width="80%"
			v-dialogDrag
      @close="onCloseSelect"
      title="选择转入账户："
      :visible.sync="showIntoModal"
			v-if="showIntoModal"
			:close-on-click-modal='false'
      append-to-body
    >
      <el-button type="primary" @click="onConfirmInto">确定</el-button>

<div class="index_2 btn-2b5a95">
        <div
          class="l-w"
          :style="{
            height: $store.state.global.isSearchExtend_2
              ? ''
              : $store.state.global.searchFormHeight_2 + 10 + 'px',
          }"
        >
          <el-form
            label-position="right"
            :class="
              $store.state.global.isSearchExtend_2 ? '' : 'overflow--hidden'
            "
            :model="selectSearchForm"
						@submit.native.prevent
          >
            <el-form-item label="开户名称:" prop="accountname">
              <el-input 
								v-model.trim="selectSearchForm.accountname"
								@keyup.enter.native="onSelectSearchClick(
                selectTableUrl,
                null,
                Object.assign({}, selectSearchForm)
              )"
								clearable />
            </el-form-item>
            <el-form-item label="银行卡号:" prop="cardno">
              <el-input 
								v-model.trim="selectSearchForm.cardno"
								@keyup.enter.native="onSelectSearchClick(
								  selectTableUrl,
								  null,
								  Object.assign({}, selectSearchForm)
								)"
								clearable />
            </el-form-item>
          </el-form>
        </div>
        <div class="r-w">
          <el-button
            type="primary"
            icon="el-icon-search"
            :loading="!$store.state.global.isEndRequest"
            class="btn-2b5a95"
            @click="
              onSelectSearchClick(
                selectTableUrl,
                null,
                Object.assign({}, selectSearchForm)
              )
            "
            >搜索</el-button
          >
					<el-button type="primary" @click="handleQuery">重置</el-button>
          <el-button
            type="primary"
            :icon="
              $store.state.global.isSearchExtend_2
                ? 'el-icon-arrow-up'
                : 'el-icon-arrow-down'
            "
            v-if="$store.state.global.searchExtend_2"
            class="btn-2b5a95"
            @click="onExtendClick('isSearchExtend_2')"
            >{{ $store.state.global.searchExtendText_2 }}</el-button
          >
        </div>
      </div>

      <el-table
        :data="selectTable.list"
        style="width: 100%"
        ref="moneyTable"
				border
				stripe
				:key="key"
				:header-cell-style="{background: '#004d8c', color:'#FFFFFF'}"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" />
        <el-table-column label="流水号" prop="id" align="center" />
        <el-table-column label="开户名称" prop="accountname" align="center" />
        <el-table-column label="银行名称" prop="bankname" align="center" />
        <el-table-column label="当前余额" prop="curmoney" align="center" />
        <el-table-column label="存折账号" prop="bookno" align="center" />
        <el-table-column label="银行卡号" prop="cardno" align="center" />
        <el-table-column
          label="是否总部POS机"
          prop="isposflag"
          align="center"
        />
        <el-table-column label="状态" prop="approvestate" align="center" />
        <el-table-column
          label="所属分公司名称"
          prop="companyorgname"
          align="center"
        />
        <el-table-column
          label="所属教学点名称"
          prop="schoolorgname"
          align="center"
        />
      </el-table>
      <el-pagination
        background
        @current-change="(val, data)=>handleSelectChange(val,selectSearchForm)"
        :current-page="selectPageInfo.pageindex"
        :page-size="selectPageInfo.pagesize"
        :page-sizes="[10, 20, 30, 40, 50]"
        layout="total, prev, pager, next, jumper"
        :total="selectTable.totalcount"
      ></el-pagination>
    </el-dialog>

    <Export
      :exportTitle="'本部转账管理'"
      :transferDialog="transferDialog"
      :exportUrl="exportUrl"
      :exportexcelUrl="exportexcelUrl"
      :exportsaveUrl="exportsaveUrl"
      :searchForm="searchForm"
      @onCloseExport="onCloseExport"
    ></Export>

    <!-- 查看详情 -->
    <el-dialog
      class="btn-2b5a95"
			v-dialogDrag
      width="60%"
      :visible.sync="showDetailModal"
      v-if="showDetailModal"
      append-to-body
			title="详情"
			:close-on-click-modal='false'
    >
      <table border="1" cellpadding="10" cellspacing="0" class="base_table">

        <tr>
          <td>转出账号流水号：{{ dynamicValidateForm.bankaccountid1 }}</td>
          <td>转入账号流水号：{{ dynamicValidateForm.bankaccountid2 }}</td>
          <td>金额：{{ dynamicValidateForm.amount }}</td>
        </tr>
        <tr>
          <td>操作时间：{{ dynamicValidateForm.optime | formatDate("YYYY-MM-DD HH:mm:ss")  }}</td>
          <td v-if="dynamicValidateForm.isquyuflag == 0">是否是区域转账：否</td>
					<td v-if="dynamicValidateForm.isquyuflag == 1">是否是区域转账：是</td>
          <td>转出银行账户当前余额：{{ dynamicValidateForm.bankcuramount1 }}</td>
        </tr>
        <tr>
          <td>转入银行账户当前余额：{{ dynamicValidateForm.bankcuramount2 }}</td>
          <td>转出账号开户名称：{{ dynamicValidateForm.bankaccountaccountname1 }}</td>
          <td>转出账号当前金额：{{ dynamicValidateForm.bankaccountcurmoney1 }}</td>
        </tr>
        <tr>
          <td>转出账号卡号：{{ dynamicValidateForm.bankaccountcardno1 }}</td>
          <td>转入账号卡号：{{ dynamicValidateForm.bankaccountbookno1 }}</td>
          <td>转入账号银行名称：{{ dynamicValidateForm.bankaccountbankname1 }}</td>
        </tr>
       <tr>
          <td>转入账号开户名称：{{ dynamicValidateForm.bankaccountaccountname2 }}</td>
          <td>转入账号当前金额：{{ dynamicValidateForm.bankaccountcurmoney2 }}</td>
          <td>转出账号折号：{{ dynamicValidateForm.bankaccountcardno2 }}</td>
        </tr>
       <tr>
          <td>转入账号折号：{{ dynamicValidateForm.bankaccountbookno2 }}</td>
          <td>转出账号银行名称：{{ dynamicValidateForm.bankaccountbankname2 }}</td>
          <td>员工编号：{{ dynamicValidateForm.usercode }}</td>
        </tr>
        <tr>
          <td>员工账户名：{{ dynamicValidateForm.username }}</td>
          <td>所属教学点序号：{{ dynamicValidateForm.schoolorgcode }}</td>
          <td>所属教学点名称：{{ dynamicValidateForm.schoolorgname }}</td>
        </tr>
        <tr>
          <td>所属分公司序号：{{ dynamicValidateForm.companyorgcode }}</td>
          <td>所属分公司名称：{{ dynamicValidateForm.companyorgname }}</td>
					<td>流水号： {{dynamicValidateForm.id}}</td>
        </tr>
      </table>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";

import { part } from "@/utils/mixins";
import Export from "@/components/Export/index.vue";
import {
  banktobank_list,
  banktobank_save,
  banktobank_export,
  banktobank_exportexcel,
  banktobank_exportsave,
} from "@/request/api/allChildrenProject";
import { _account_dialogbankresult } from "@/request/api/public";
import { myRequest } from "@/request/index";
import {
  selectCheck,
  confirmCallBack,
  messageTip,
  createObjParams,
  formatDare,
} from "@/utils/util";

export default {
  mixins: [part],
  name: "banktobank",
  components: { Export },
  props: {
    exportUrl: {
      default: () => banktobank_export,
    },
    exportexcelUrl: {
      default: () => banktobank_exportexcel,
    },
    exportsaveUrl: {
      default: () => banktobank_exportsave,
    },

    account_dialogbankresult: {
      default: () => _account_dialogbankresult,
    },
  },
  data() {
    //数值表单规则
    var checkfield = (rule, value, callback) => {
      if (!(value + "")) {
        return callback(new Error("必填字段"));
      } else {
        if (isNaN(Number(value))) {
          callback(new Error("请输入数字值"));
        } else {
          callback();
        }
      }
    };
    return {
      transferDialog: false, //导出框

      itemId: null, //首表格项id
      searchForm: {},
      tableRes: {}, //列表接口
      pageinfo: {
        pageindex: 1,
        pagesize: 10,
      }, //页数查询
      showAddModal: false, //显示表单框
      multipleSelection: [], //选中的表格项
      dynamicValidateForm: {}, //表单
      rules: {
        cashaccountname: [
          { trigger: "blur", message: "必填字段", required: true },
        ],
        bankaccountaccountname: [
          { trigger: "blur", message: "必填字段", required: true },
        ],
        amount: [{ trigger: "blur", message: "必填字段", required: true }],
        optime: [{ trigger: "blur", message: "必填字段", required: true }],
      }, //表单规则
      dialogTitle: "", //对话框标题
      selectTable: {},
      selectTableUrl: "",
      selectPageInfo: {
        pageindex: 1,
        pagesize: 10,
      },
			key: '',
      selectSearchForm:{},
      showIntoModal: false, //转入
      showOutModal: false, //转出
      showDetailModal: false,

    };
  },
  created() {
    this.getDataList();
  },
  methods: {
    ...mapActions("global", ["onExtendClick", "isExpand"]),
		reset() {
			this.searchForm = {
				amount: null,
				bankaccountcardno1: null,
				bankaccountbookno1:null,
				schoolorgname: null,
				username:null,
			}
		},
		selectQuery() {
			this.selectSearchForm = {
				accountname: null,
				cardno: null
			}
		},
		handleQuery() {
			this.selectQuery();
			this.onSelectData(this.selectTableUrl, null, null);
		},
		//重置
		resetQuery() {
			this.reset();
			this.getDataList();
		},
    onCloseExport(bool) {
      this.transferDialog = false;
    },
    //导出 click
    btnExport() {
      this.transferDialog = true;
    },
    //搜索 click
    seach() {
      this.pageinfo.pageindex = 1;
      this.getDataList();
    },
    //列表查询 api
    getDataList() {
      myRequest({
        url: banktobank_list,
        data: Object.assign(this.searchForm, this.pageinfo),
      }).then((res) => {
        if (res.data.code === "200") {
          this.tableRes = res.data.data;
        }
      });
    },
    //切换当前页
    handleCurrentChange(val) {
      this.pageinfo.pageindex = val;
      this.getDataList();
    },
    //切换选项表格页
    handleSelectChange(val,data) {
      this.selectPageInfo.pageindex = val;
      this.onSelectData(this.selectTableUrl,null,data);
    },
    //触发所有btn方法
    onClickBtn(methodsName) {
      this.$options.methods[methodsName].call(this); //btnAdd ... （防止修改this指向）
    },
    // 查看详情 click
    btnShowDetail(row) {
      this.dynamicValidateForm = JSON.parse(JSON.stringify(row));
      this.showDetailModal = true;
    },
    //添加click
    btnAdd() {
      this.dialogTitle = "添加";
      this.dynamicValidateForm = {};
      this.showAddModal = true;
    },
    //刷新 click
    btnReload() {
      this.getDataList();
    },
    //确认转出 click
    onConfirmOut() {
      selectCheck(this.multipleSelection, "转出", false, () => {
        this.$set(this.dynamicValidateForm,'bankaccountcardno1',this.multipleSelection[0].cardno)
        this.$set(this.dynamicValidateForm,'bankcuramount1',this.multipleSelection[0].curmoney)
        this.$set(this.dynamicValidateForm,'cashaccountname',this.multipleSelection[0].accountname)
        this.dynamicValidateForm.bankaccountid1 = this.multipleSelection[0].id;
        this.showOutModal = false;
				this.multipleSelection = [];
				this.selectQuery();
      });
    },
    //确认转入 click
    onConfirmInto() {
      selectCheck(this.multipleSelection, "转入", false, () => {
        this.$set(this.dynamicValidateForm,'bankaccountbookno1',this.multipleSelection[0].cardno)
        this.$set(this.dynamicValidateForm,'bankcuramount2',this.multipleSelection[0].curmoney)
        this.$set(this.dynamicValidateForm,'bankaccountaccountname',this.multipleSelection[0].accountname)
        this.dynamicValidateForm.bankaccountid2 = this.multipleSelection[0].id;
        this.showIntoModal = false;
				this.multipleSelection = [];
				this.selectQuery();
      });
    },
    //提交-（添加，修改） api
    submitAddOrEditForm(dynamicValidateForm) {
      this.$refs[dynamicValidateForm].validate((valid) => {
        if (valid) {
          myRequest(
            {
              url: banktobank_save,
              data: this.dynamicValidateForm,
            },
            {
              isRefTableList: true,
              that: this,
              
              modal: "showAddModal",
            }
          );
        }
      });
    },
    //选中表格数据改变时
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //选项表格 api（转入，转出）
    onSelectData(url, modal, data) {
      this.selectTableUrl = url
      myRequest({
        url: this.selectTableUrl,
        data: Object.assign(data||{}, this.selectPageInfo),
      }).then((res) => {
        if (res.data.code === "200") {
          this.$refs.multipleTable && this.$refs.multipleTable.clearSelection();
          this.selectTable = res.data.data;
					this.key = Math.random();
          this[modal] = true;
        }
      });
    },
    //选项表格 - 搜索 click
    onSelectSearchClick(url,modal,data){
      this.selectPageInfo.pageindex = 1
      this.onSelectData(url,modal,data)
			this.onCloseSelect();
    },
    //关闭选项框 click
    onCloseSelect(){
      this.selectPageInfo.pageindex = 1
    },
  },
};
</script>

<style  lang="scss">
	.base_table{
		margin: auto;
	}
</style>